<template>
    <div class="lg:hidden fixed w-full h-full inset-0 bg-gray-300 opacity-75 z-50"  @click="$emit('click')"></div>
</template>
<script>
export default {
    name: 'Overlay'
}
</script>    